<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="loading-order-container">
  <div>
    <frodo-title [text]="title"></frodo-title>
  </div>
  <div *ngIf="!showButtons">
    <frodo-button
      name="cancel-button"
      [backgroundColor]="backgroundColorCancel"
      [text]="buttonTextCancel"
      (onClick)="onCancel()"
      [disable]="isLoading"
    ></frodo-button>
  </div>
  <div *ngIf="showButtons" class="buttons-container">
    <frodo-button
      name="cancel-button"
      [backgroundColor]="backgroundColorCancel"
      [text]="buttonTextCancel"
      (onClick)="onCancel()"
      [disable]="isLoading"
    ></frodo-button>
    <frodo-button
      name="add-space-button"
      [backgroundColor]="backgroundColorAddSpace"
      [text]="buttonTextAddSpace"
      [disable]="isLoading || disableAddCompartmentButton || !actionsEnabled"
      (onClick)="onAddSpace()"
    ></frodo-button>
    <frodo-button
      name="complete-button"
      [backgroundColor]="backgroundColorComplete"
      [text]="buttonTextComplete"
      (onClick)="onComplete()"
      [disable]="isLoading || !actionsEnabled"
    ></frodo-button>
  </div>
  <div><frodo-logo [src]="logo" [alt]="logoAlt" (click)="refresh()"></frodo-logo></div>
</div>
